import TransferManagement from "./transfer_management";

export default function PendingTransfert() {
  return <TransferManagement defaultStatus={0} />;
}
